import request from '@/utils/requestThingsBoard'

// 获取对应project下的asset设置
export function getProjectAsset (projectId) {
  return request({
    url: '/project/assets/' + projectId + '?limit=999999',
    method: 'get'
  })
}

export function getTenantAsset () {
  return request({
    url: '/tenant/assets?limit=999999',
    method: 'get'
  })
}

// 这个方法 tenantId 换 projectId
export function saveAsset (params) {
  return request({
    url: '/asset',
    method: 'post',
    data: params
  })
}

export function deleteAsset (assetId) {
  return request({
    url: '/asset/' + assetId,
    method: 'delete'
  })
}
